import { render, staticRenderFns } from "./UiAddress.vue?vue&type=template&id=90550ab4"
import script from "./UiAddress.vue?vue&type=script&lang=js"
export * from "./UiAddress.vue?vue&type=script&lang=js"
import style0 from "./UiAddress.vue?vue&type=style&index=0&id=90550ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports